import {
  fetchContent,
  MultipleItemResponse,
  SingleItemResponse,
} from "./fetchContent"

type Args = {
  language: string
  urlSlug: string
  preview?: boolean
}

export const getCollectionDetailPage = async <CollectionDetailPage>({
  language,
  urlSlug,
  preview,
}: Args): Promise<SingleItemResponse<CollectionDetailPage>> => {
  const response: MultipleItemResponse<CollectionDetailPage> =
    await fetchContent({
      path: "",
      preview,
      params: {
        language: language || "en",
        "system.type[in]": [
          "collection_detail_page",
          "collection_separate_items_page",
        ],
        limit: 1,
        "elements.url_slug": urlSlug,
      },
    })

  if (response.pagination.count === 0) {
    throw new Error(
      `Cannot find collection detail page with url slug ${urlSlug}`
    )
  }

  return {
    item: response.items[0],
    modular_content: response.modular_content,
  }
}
